// extracted by mini-css-extract-plugin
export default {"titlePage":"databaseApplication_titlePage__K1bqn"};